import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { FaRegMoon } from 'react-icons/fa';
import { useThemeMode } from '../contexts/ThemeContext';
import { IoSunnyOutline } from 'react-icons/io5';
import { t } from 'i18next';
import PropTypes from 'prop-types';

const ThemeToggle = ({ className, useLabel = true, iconColor }) => {
  const { mode, toggleColorMode } = useThemeMode();

  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <button
        onClick={toggleColorMode}
        color='inherit'
        style={{ color: 'var(--tblr-body-color)' }}
        className={`cursor-pointer no-appearance ${className || ''}`}
      >
        {mode === 'dark' ? (
          <IoSunnyOutline color='#ffffffff' size={25} />
        ) : (
          <Box component='span' sx={{ marginLeft: '0.35em' }}>
            <FaRegMoon size={18} />
          </Box>
        )}
        {useLabel && (
          <span className='ms-2'>{t(mode === 'light' ? `darkMode` : `lightMode`)}</span>
        )}
      </button>
    </Tooltip>
  );
};

export default ThemeToggle;

ThemeToggle.propTypes = {
  className: PropTypes.string,
  useLabel: PropTypes.bool,
  iconColor: PropTypes.string,
};
